"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaCommand = void 0;
class CollaCommand {
    constructor(_cmdDef, name) {
        this._cmdDef = _cmdDef;
        this.name = name;
    }
    undoable() {
        return this._cmdDef.undoable;
    }
    canUndo(context, actions) {
        if (!this.undoable()) {
            return false;
        }
        return this._cmdDef.canUndo ? this._cmdDef.canUndo(context, actions) : true;
    }
    canRedo(context, actions) {
        if (!this.undoable()) {
            return false;
        }
        return this._cmdDef.canRedo ? this._cmdDef.canRedo(context, actions) : true;
    }
    /**
     * @returns {boolean} returns true, indicating that the result of execution can be placed in
     */
    execute(context, options) {
        return this._cmdDef.execute(context, options);
    }
}
exports.CollaCommand = CollaCommand;
//# sourceMappingURL=command.js.map